import type { LumirProduct } from '@environment';

/**
 * Whether a product is offered to a user of another surface. Two conditions: an address — the host is up,
 * a link to nowhere is worse than no row; and readiness — for Фотобук that is `PHOTOBOOK_MENU_ENABLED`,
 * off on prod. The product menu and the notification feed filter both ask this, so a product hidden from
 * one is hidden from the other.
 */
export function isProductOffered(product: LumirProduct, photobookMenuEnabled: boolean): boolean {
  return !!product.url && (product.id !== 'photobook' || photobookMenuEnabled);
}
